<button class="btn cx-product-layout" [ngClass]="buttonClass" (click)="changeMode()">
  @if (viewMode === iconTypes.GRID) {
    <cx-icon [type]="iconTypes.GRID"></cx-icon>
  }
  @if (viewMode === iconTypes.LIST) {
    <cx-icon [type]="iconTypes.LIST"></cx-icon>
  }
</button>
